import { render } from "./Run.vue?vue&type=template&id=60be62c0&scoped=true"
import script from "./Run.vue?vue&type=script&lang=js"
export * from "./Run.vue?vue&type=script&lang=js"

import "./Run.vue?vue&type=style&index=0&id=60be62c0&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60be62c0"]])

export default __exports__